import type { IconSvgObject } from './types';

const ToggleRightIcon: IconSvgObject = [
  ["path", { d: "M13 12C13 13.6569 14.3431 15 16 15C17.6569 15 19 13.6569 19 12C19 10.3431 17.6569 9 16 9C14.3431 9 13 10.3431 13 12Z", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8 6H16C19.3137 6 22 8.68629 22 12C22 15.3137 19.3137 18 16 18H8C4.68629 18 2 15.3137 2 12C2 8.68629 4.68629 6 8 6Z", stroke: "currentColor", strokeWidth: "1.5", key: "1" }]
];

export default ToggleRightIcon;
